import { ChangeDetectionStrategy, Component } from '@angular/core';
import { IconModule } from '@library/ui/atoms/icon/icon.module';
import { ToolbarItemComponent } from 'src/app/toolbar/toolbar-item/toolbar-item.component';

@Component({
  selector: 'app-zoom',
  imports: [
    ToolbarItemComponent,
    IconModule,
  ],
  templateUrl: './zoom.component.html',
  styleUrl: './zoom.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ZoomComponent {
  zoomIn(): void {
    window.map.zoomIn();
  }

  zoomOut(): void {
    window.map.zoomOut();
  }
}
